<template>
  <v-app id="inspire" :style="{ backgroundColor: bgColor }">
    <!-- <Header v-if="loginState"/>
    <Sidebar v-if="loginState"/> -->

    <Navigation v-if="logged" />
    <LoginPage v-else />
    <v-main>
      <v-container v-if="logged" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

import Navigation from "./components/dashboard/Navigation.vue";
import LoginPage from "./views/Login.vue";
// import {mapGetters } from "vuex"

export default {
  components: {
    Navigation,
    LoginPage,
  },
  data: () => ({
    bgColor: "#f6f6f6",
  }),
  computed: {
    ...mapState({
      logged: (state) => state.user.logged,
    }),
  },

  created() {
    if (this.$route.path !== "/login") this.$store.dispatch("user/checkLogin");
  },
};
</script>
